import React from 'react'
import { Divider, Button, Space, PageHeader } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import {
  CompanyBalanceData,
  CompanyCredit,
  CompanyData,
} from '../../../services/api/companies'
import { BackButton } from '../../../components'
import { editCompanyPath } from '../../../routes/paths'
import {
  Card,
  Signer,
  Commission,
  Stats,
  Balance,
  Settings,
  Credit,
} from './components'
import styles from './styles.module.css'

type Props = {
  company: CompanyData
  balance: CompanyBalanceData
  credit?: CompanyCredit
  onCompanyBalanceUpdate: () => void
}

export const View: React.FunctionComponent<Props> = ({
  company,
  balance,
  credit,
  onCompanyBalanceUpdate,
}) => {
  return (
    <>
      <PageHeader
        title={company.name}
        subTitle="Данные о компании"
        className={styles.pageHeader}
      />

      <Divider />

      <Balance
        balance={balance}
        companyId={company.id}
        onBalanceUpdate={onCompanyBalanceUpdate}
      />
      <Credit
        companyId={company.id}
        credit={credit}
        currency={balance.currency}
        debt={-balance.amount}
        onCreditUpdate={() => onCompanyBalanceUpdate()}
      />

      <Divider />

      <Card company={company} />

      <Divider />

      <Stats companyId={company.id} />

      <Divider />

      {company.signer && (
        <>
          <Signer signer={company.signer} />
          <Divider />
        </>
      )}

      {company.commission && (
        <>
          <Commission commission={company.commission} />
          <Divider />
        </>
      )}

      <Settings company={company} />

      <Divider />

      <Space>
        <Button type="primary" href={editCompanyPath(company.id)}>
          <EditOutlined />
          Редактировать
        </Button>
        <BackButton />
      </Space>
    </>
  )
}
